// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M6cU","badges":"styles_badges__2j3BW"};